import styles from '../StoreAvailability.module.scss';

const StoreAvailabilityPickupTime = () => {
  return (
    <p
      className={`cat-u-margin-bottom-none cat-u-margin-top-sm fw-bold ${styles['cutoff-time-text']}`}
    >
      Order within {0} hrs {1} mins
    </p>
  );
};
export default StoreAvailabilityPickupTime;
